import { AxiosInstance } from "axios";
import axiosHelper from "../axiosHelper";
import ServiceJobOperationModel from "@/models/ServiceJobOperationModel";

export default class JobOperationsApiHelper {

	getJobsByOperationHttpClient: AxiosInstance;
	componentOperationsHttpClient: AxiosInstance;

	constructor(jwt: string) {
		this.getJobsByOperationHttpClient = axiosHelper.createInstance(jwt);
		this.componentOperationsHttpClient = axiosHelper.createInstance(jwt);
	}

	/** gets service-job IDs array that are related to operationId */
	async getJobOperationsAsync(operationId: number): Promise<Array<number> | null> {
		try {
			const jobCategoriesResponse = await this.getJobsByOperationHttpClient.get(`/api/servicejoboperations/rels/${operationId}`);
			return jobCategoriesResponse.data.map((_: number) => _);
		} catch (e) {			
			console.error(`Error getting jobs IDs that are related to service-job-operation #${operationId}`, e);
			return null;
		}
	}

	/** get list of service-operations are related to a component */
	async getComponentOperationsAsync(componentId: number, defaultOperationsOnly: boolean) : Promise<Array<ServiceJobOperationModel> | null> {
		try {
			const results = await this.componentOperationsHttpClient.get(`/api/servicejoboperations/component/${componentId}?defaultOperationsOnly=${defaultOperationsOnly}`);
			if (!results.data?.length) {
				return [];
			}
			
			return results.data.map((_: any) => new ServiceJobOperationModel(_))!;
		} catch (e) {
			console.error(`Error getting operations of component #${componentId}`, e);
			return null;
		}
	}
}